export const resourcesCurrency = [
  {
    id: "1",
    resourceCode: "AED",
    resourceId: "784",
    resourceName: "United Arab Emirates dirham",
  },
  {
    id: "2",
    resourceCode: "AFN",
    resourceId: "971",
    resourceName: "Afghan afghani",
  },
  {
    id: "3",
    resourceCode: "ALL",
    resourceId: "008",
    resourceName: "Albanian lek",
  },
  {
    id: "4",
    resourceCode: "AMD",
    resourceId: "051",
    resourceName: "Armenian dram",
  },
  {
    id: "5",
    resourceCode: "ANG",
    resourceId: "532",
    resourceName: "Netherlands Antillean guilder",
  },
  {
    id: "6",
    resourceCode: "AOA",
    resourceId: "973",
    resourceName: "Angolan kwanza",
  },
  {
    id: "7",
    resourceCode: "ARS",
    resourceId: "032",
    resourceName: "Argentine peso",
  },
  {
    id: "8",
    resourceCode: "AUD",
    resourceId: "036",
    resourceName: "Australian dollar",
  },
  {
    id: "9",
    resourceCode: "AWG",
    resourceId: "533",
    resourceName: "Aruban florin",
  },
  {
    id: "10",
    resourceCode: "AZN",
    resourceId: "944",
    resourceName: "Azerbaijani manat",
  },
  {
    id: "11",
    resourceCode: "BAM",
    resourceId: "977",
    resourceName: "Bosnia and Herzegovina convertible mark",
  },
  {
    id: "12",
    resourceCode: "BBD",
    resourceId: "052",
    resourceName: "Barbados dollar",
  },
  {
    id: "13",
    resourceCode: "BDT",
    resourceId: "050",
    resourceName: "Bangladeshi taka",
  },
  {
    id: "14",
    resourceCode: "BGN",
    resourceId: "975",
    resourceName: "Bulgarian lev",
  },
  {
    id: "15",
    resourceCode: "BHD",
    resourceId: "048",
    resourceName: "Bahraini dinar",
  },
  {
    id: "16",
    resourceCode: "BIF",
    resourceId: "108",
    resourceName: "Burundian franc",
  },
  {
    id: "17",
    resourceCode: "BMD",
    resourceId: "060",
    resourceName: "Bermudian dollar",
  },
  {
    id: "18",
    resourceCode: "BND",
    resourceId: "096",
    resourceName: "Brunei dollar",
  },
  {
    id: "19",
    resourceCode: "BOB",
    resourceId: "068",
    resourceName: "Boliviano",
  },
  {
    id: "20",
    resourceCode: "BOV",
    resourceId: "984",
    resourceName: "Bolivian Mvdol (funds code)",
  },
  {
    id: "21",
    resourceCode: "BRL",
    resourceId: "986",
    resourceName: "Brazilian real",
  },
  {
    id: "22",
    resourceCode: "BSD",
    resourceId: "044",
    resourceName: "Bahamian dollar",
  },
  {
    id: "23",
    resourceCode: "BTN",
    resourceId: "064",
    resourceName: "Bhutanese ngultrum",
  },
  {
    id: "24",
    resourceCode: "BWP",
    resourceId: "072",
    resourceName: "Botswana pula",
  },
  {
    id: "25",
    resourceCode: "BYN",
    resourceId: "933",
    resourceName: "Belarusian ruble",
  },
  {
    id: "26",
    resourceCode: "BZD",
    resourceId: "084",
    resourceName: "Belize dollar",
  },
  {
    id: "27",
    resourceCode: "CAD",
    resourceId: "124",
    resourceName: "Canadian dollar",
  },
  {
    id: "28",
    resourceCode: "CDF",
    resourceId: "976",
    resourceName: "Congolese franc",
  },
  {
    id: "29",
    resourceCode: "CHE",
    resourceId: "947",
    resourceName: "WIR euro (complementary currency)",
  },
  {
    id: "30",
    resourceCode: "CHF",
    resourceId: "756",
    resourceName: "Swiss franc",
  },
  {
    id: "31",
    resourceCode: "CHW",
    resourceId: "948",
    resourceName: "WIR franc (complementary currency)",
  },
  {
    id: "32",
    resourceCode: "CLF",
    resourceId: "990",
    resourceName: "Unidad de Fomento",
  },
  {
    id: "33",
    resourceCode: "CLP",
    resourceId: "152",
    resourceName: "Chilean peso",
  },
  {
    id: "34",
    resourceCode: "COP",
    resourceId: "170",
    resourceName: "Colombian peso",
  },
  {
    id: "35",
    resourceCode: "COU",
    resourceId: "970",
    resourceName: "Unidad de Valor Real",
  },
  {
    id: "36",
    resourceCode: "CRC",
    resourceId: "188",
    resourceName: "Costa Rican colon",
  },
  {
    id: "37",
    resourceCode: "CUC",
    resourceId: "931",
    resourceName: "Cuban convertible peso",
  },
  {
    id: "38",
    resourceCode: "CUP",
    resourceId: "192",
    resourceName: "Cuban peso",
  },
  {
    id: "39",
    resourceCode: "CVE",
    resourceId: "132",
    resourceName: "Cape Verdean escudo",
  },
  {
    id: "40",
    resourceCode: "CZK",
    resourceId: "203",
    resourceName: "Czech koruna",
  },
  {
    id: "41",
    resourceCode: "DJF",
    resourceId: "262",
    resourceName: "Djiboutian franc",
  },
  {
    id: "42",
    resourceCode: "DKK",
    resourceId: "208",
    resourceName: "Danish krone",
  },
  {
    id: "43",
    resourceCode: "DOP",
    resourceId: "214",
    resourceName: "Dominican peso",
  },
  {
    id: "44",
    resourceCode: "DZD",
    resourceId: "012",
    resourceName: "Algerian dinar",
  },
  {
    id: "45",
    resourceCode: "EGP",
    resourceId: "818",
    resourceName: "Egyptian pound",
  },
  {
    id: "46",
    resourceCode: "ERN",
    resourceId: "232",
    resourceName: "Eritrean nakfa",
  },
  {
    id: "47",
    resourceCode: "ETB",
    resourceId: "230",
    resourceName: "Ethiopian birr",
  },
  {
    id: "48",
    resourceCode: "EUR",
    resourceId: "978",
    resourceName: "Euro",
  },
  {
    id: "49",
    resourceCode: "FJD",
    resourceId: "242",
    resourceName: "Fiji dollar",
  },
  {
    id: "50",
    resourceCode: "FKP",
    resourceId: "238",
    resourceName: "Falkland Islands pound",
  },
  {
    id: "51",
    resourceCode: "GBP",
    resourceId: "826",
    resourceName: "Pound sterling",
  },
  {
    id: "52",
    resourceCode: "GEL",
    resourceId: "981",
    resourceName: "Georgian lari",
  },
  {
    id: "53",
    resourceCode: "GHS",
    resourceId: "936",
    resourceName: "Ghanaian cedi",
  },
  {
    id: "54",
    resourceCode: "GIP",
    resourceId: "292",
    resourceName: "Gibraltar pound",
  },
  {
    id: "55",
    resourceCode: "GMD",
    resourceId: "270",
    resourceName: "Gambian dalasi",
  },
  {
    id: "56",
    resourceCode: "GNF",
    resourceId: "324",
    resourceName: "Guinean franc",
  },
  {
    id: "57",
    resourceCode: "GTQ",
    resourceId: "320",
    resourceName: "Guatemalan quetzal",
  },
  {
    id: "58",
    resourceCode: "GYD",
    resourceId: "328",
    resourceName: "Guyanese dollar",
  },
  {
    id: "59",
    resourceCode: "HKD",
    resourceId: "344",
    resourceName: "Hong Kong dollar",
  },
  {
    id: "60",
    resourceCode: "HNL",
    resourceId: "340",
    resourceName: "Honduran lempira",
  },
  {
    id: "61",
    resourceCode: "HRK",
    resourceId: "191",
    resourceName: "Croatian kuna",
  },
  {
    id: "62",
    resourceCode: "HTG",
    resourceId: "332  ",
    resourceName: "Haitian gourde",
  },
  {
    id: "63",
    resourceCode: "HUF",
    resourceId: "348",
    resourceName: "Hungarian forint",
  },
  {
    id: "64",
    resourceCode: "IDR",
    resourceId: "360",
    resourceName: "Indonesian rupiah",
  },
  {
    id: "65",
    resourceCode: "ILS",
    resourceId: "376",
    resourceName: "Israeli new shekel",
  },
  {
    id: "66",
    resourceCode: "INR",
    resourceId: "356",
    resourceName: "Indian rupee",
  },
  {
    id: "67",
    resourceCode: "IQD",
    resourceId: "368",
    resourceName: "Iraqi dinar",
  },
  {
    id: "68",
    resourceCode: "IRR",
    resourceId: "364",
    resourceName: "Iranian rial",
  },
  {
    id: "69",
    resourceCode: "ISK",
    resourceId: "352",
    resourceName: "Icelandic króna",
  },
  {
    id: "70",
    resourceCode: "JMD",
    resourceId: "388",
    resourceName: "Jamaican dollar",
  },
  {
    id: "71",
    resourceCode: "JOD",
    resourceId: "400",
    resourceName: "Jordanian dinar",
  },
  {
    id: "72",
    resourceCode: "JPY",
    resourceId: "392",
    resourceName: "Japanese yen",
  },
  {
    id: "73",
    resourceCode: "KES",
    resourceId: "404",
    resourceName: "Kenyan shilling",
  },
  {
    id: "74",
    resourceCode: "KGS",
    resourceId: "417",
    resourceName: "Kyrgyzstani som",
  },
  {
    id: "75",
    resourceCode: "KHR",
    resourceId: "116",
    resourceName: "Cambodian riel",
  },
  {
    id: "76",
    resourceCode: "KMF",
    resourceId: "174",
    resourceName: "Comoro franc",
  },
  {
    id: "77",
    resourceCode: "KPW",
    resourceId: "408",
    resourceName: "North Korean won",
  },
  {
    id: "78",
    resourceCode: "KRW",
    resourceId: "410",
    resourceName: "South Korean won",
  },
  {
    id: "79",
    resourceCode: "KWD",
    resourceId: "414",
    resourceName: "Kuwaiti dinar",
  },
  {
    id: "80",
    resourceCode: "KYD",
    resourceId: "136",
    resourceName: "Cayman Islands dollar",
  },
  {
    id: "81",
    resourceCode: "KZT",
    resourceId: "398",
    resourceName: "Kazakhstani tenge",
  },
  {
    id: "82",
    resourceCode: "LAK",
    resourceId: "418",
    resourceName: "Lao kip",
  },
  {
    id: "83",
    resourceCode: "LBP",
    resourceId: "422",
    resourceName: "Lebanese pound",
  },
  {
    id: "84",
    resourceCode: "LKR",
    resourceId: "144",
    resourceName: "Sri Lankan rupee",
  },
  {
    id: "85",
    resourceCode: "LRD",
    resourceId: "430",
    resourceName: "Liberian dollar",
  },
  {
    id: "86",
    resourceCode: "LSL",
    resourceId: "426",
    resourceName: "Lesotho loti",
  },
  {
    id: "87",
    resourceCode: "LYD",
    resourceId: "434",
    resourceName: "Libyan dinar",
  },
  {
    id: "88",
    resourceCode: "MAD",
    resourceId: "504",
    resourceName: "Moroccan dirham",
  },
  {
    id: "89",
    resourceCode: "MDL",
    resourceId: "498",
    resourceName: "Moldovan leu",
  },
  {
    id: "90",
    resourceCode: "MGA",
    resourceId: "969",
    resourceName: "Malagasy ariary",
  },
  {
    id: "91",
    resourceCode: "MKD",
    resourceId: "807",
    resourceName: "Macedonian denar",
  },
  {
    id: "92",
    resourceCode: "MMK",
    resourceId: "104",
    resourceName: "Myanmar kyat",
  },
  {
    id: "93",
    resourceCode: "MNT",
    resourceId: "496",
    resourceName: "Mongolian tögrög",
  },
  {
    id: "94",
    resourceCode: "MOP",
    resourceId: "446",
    resourceName: "Macanese pataca",
  },
  {
    id: "95",
    resourceCode: "MRU",
    resourceId: "929",
    resourceName: "Mauritanian ouguiya",
  },
  {
    id: "96",
    resourceCode: "MUR",
    resourceId: "480",
    resourceName: "Mauritian rupee",
  },
  {
    id: "97",
    resourceCode: "MVR",
    resourceId: "462",
    resourceName: "Maldivian rufiyaa",
  },
  {
    id: "98",
    resourceCode: "MWK",
    resourceId: "454",
    resourceName: "Malawian kwacha",
  },
  {
    id: "99",
    resourceCode: "MXN",
    resourceId: "484",
    resourceName: "Mexican peso",
  },
  {
    id: "100",
    resourceCode: "MXV",
    resourceId: "979",
    resourceName: "Mexican Unidad de Inversion",
  },
  {
    id: "101",
    resourceCode: "MYR",
    resourceId: "458",
    resourceName: "Malaysian ringgit",
  },
  {
    id: "102",
    resourceCode: "MZN",
    resourceId: "943",
    resourceName: "Mozambican metical",
  },
  {
    id: "103",
    resourceCode: "NAD",
    resourceId: "516",
    resourceName: "Namibian dollar",
  },
  {
    id: "104",
    resourceCode: "NGN",
    resourceId: "566",
    resourceName: "Nigerian naira",
  },
  {
    id: "105",
    resourceCode: "NIO",
    resourceId: "558",
    resourceName: "Nicaraguan córdoba",
  },
  {
    id: "106",
    resourceCode: "NOK",
    resourceId: "578",
    resourceName: "Norwegian krone",
  },
  {
    id: "107",
    resourceCode: "NPR",
    resourceId: "524",
    resourceName: "Nepalese rupee",
  },
  {
    id: "108",
    resourceCode: "NZD",
    resourceId: "554",
    resourceName: "New Zealand dollar",
  },
  {
    id: "109",
    resourceCode: "OMR",
    resourceId: "512",
    resourceName: "Omani rial",
  },
  {
    id: "110",
    resourceCode: "PAB",
    resourceId: "590",
    resourceName: "Panamanian balboa",
  },
  {
    id: "111",
    resourceCode: "PEN",
    resourceId: "604",
    resourceName: "Peruvian sol",
  },
  {
    id: "112",
    resourceCode: "PGK",
    resourceId: "598",
    resourceName: "Papua New Guinean kina",
  },
  {
    id: "113",
    resourceCode: "PHP",
    resourceId: "608",
    resourceName: "Philippine peso",
  },
  {
    id: "114",
    resourceCode: "PKR",
    resourceId: "586",
    resourceName: "Pakistani rupee",
  },
  {
    id: "115",
    resourceCode: "PLN",
    resourceId: "985",
    resourceName: "Polish złoty",
  },
  {
    id: "116",
    resourceCode: "PYG",
    resourceId: "600",
    resourceName: "Paraguayan guaraní",
  },
  {
    id: "117",
    resourceCode: "QAR",
    resourceId: "634",
    resourceName: "Qatari riyal",
  },
  {
    id: "118",
    resourceCode: "RON",
    resourceId: "946",
    resourceName: "Romanian leu",
  },
  {
    id: "119",
    resourceCode: "RSD",
    resourceId: "941",
    resourceName: "Serbian dinar",
  },
  {
    id: "120",
    resourceCode: "CNY",
    resourceId: "156",
    resourceName: "Renminbi[",
  },
  {
    id: "121",
    resourceCode: "RUB",
    resourceId: "643",
    resourceName: "Russian ruble",
  },
  {
    id: "122",
    resourceCode: "RWF",
    resourceId: "646",
    resourceName: "Rwandan franc",
  },
  {
    id: "123",
    resourceCode: "SAR",
    resourceId: "682",
    resourceName: "Saudi riyal",
  },
  {
    id: "124",
    resourceCode: "SBD",
    resourceId: "090",
    resourceName: "Solomon Islands dollar",
  },
  {
    id: "125",
    resourceCode: "SCR",
    resourceId: "690",
    resourceName: "Seychelles rupee",
  },
  {
    id: "126",
    resourceCode: "SDG",
    resourceId: "938",
    resourceName: "Sudanese pound",
  },
  {
    id: "127",
    resourceCode: "SEK",
    resourceId: "752",
    resourceName: "Swedish krona",
  },
  {
    id: "128",
    resourceCode: "SGD",
    resourceId: "702",
    resourceName: "Singapore dollar",
  },
  {
    id: "129",
    resourceCode: "SHP",
    resourceId: "654",
    resourceName: "Saint Helena pound",
  },
  {
    id: "130",
    resourceCode: "SLE",
    resourceId: "925",
    resourceName: "Sierra Leonean leone",
  },
  {
    id: "131",
    resourceCode: "SOS",
    resourceId: "706",
    resourceName: "Somali shilling",
  },
  {
    id: "132",
    resourceCode: "SRD",
    resourceId: "968",
    resourceName: "Surinamese dollar",
  },
  {
    id: "133",
    resourceCode: "SSP",
    resourceId: "728",
    resourceName: "South Sudanese pound",
  },
  {
    id: "134",
    resourceCode: "STN",
    resourceId: "930",
    resourceName: "São Tomé and Príncipe dobra",
  },
  {
    id: "135",
    resourceCode: "SVC",
    resourceId: "222",
    resourceName: "Salvadoran colón",
  },
  {
    id: "136",
    resourceCode: "SYP",
    resourceId: "760",
    resourceName: "Syrian pound",
  },
  {
    id: "137",
    resourceCode: "SZL",
    resourceId: "748",
    resourceName: "Swazi lilangeni",
  },
  {
    id: "138",
    resourceCode: "THB",
    resourceId: "764",
    resourceName: "Thai baht",
  },
  {
    id: "139",
    resourceCode: "TJS",
    resourceId: "972",
    resourceName: "Tajikistani somoni",
  },
  {
    id: "140",
    resourceCode: "TMT",
    resourceId: "934",
    resourceName: "Turkmenistan manat",
  },
  {
    id: "141",
    resourceCode: "TND",
    resourceId: "788",
    resourceName: "Tunisian dinar",
  },
  {
    id: "142",
    resourceCode: "TOP",
    resourceId: "776",
    resourceName: "Tongan paʻanga",
  },
  {
    id: "143",
    resourceCode: "TRY",
    resourceId: "949",
    resourceName: "Turkish lira",
  },
  {
    id: "144",
    resourceCode: "TTD",
    resourceId: "780",
    resourceName: "Trinidad and Tobago dollar",
  },
  {
    id: "145",
    resourceCode: "TWD",
    resourceId: "901",
    resourceName: "New Taiwan dollar",
  },
  {
    id: "146",
    resourceCode: "TZS",
    resourceId: "834",
    resourceName: "Tanzanian shilling",
  },
  {
    id: "147",
    resourceCode: "UAH",
    resourceId: "980",
    resourceName: "Ukrainian hryvnia",
  },
  {
    id: "148",
    resourceCode: "UGX",
    resourceId: "800",
    resourceName: "Ugandan shilling",
  },
  {
    id: "149",
    resourceCode: "USD",
    resourceId: "840",
    resourceName: "United States dollar",
  },
  {
    id: "150",
    resourceCode: "UYU",
    resourceId: "858",
    resourceName: "Uruguayan peso",
  },
  {
    id: "151",
    resourceCode: "UZS",
    resourceId: "860",
    resourceName: "Uzbekistan sum",
  },
  {
    id: "152",
    resourceCode: "VED",
    resourceId: "926",
    resourceName: "Venezuelan digital bolívar",
  },
  {
    id: "153",
    resourceCode: "VES",
    resourceId: "928",
    resourceName: "Venezuelan sovereign bolívar",
  },
  {
    id: "154",
    resourceCode: "VND",
    resourceId: "704",
    resourceName: "Vietnamese đồng",
  },
  {
    id: "155",
    resourceCode: "VUV",
    resourceId: "548",
    resourceName: "Vanuatu vatu",
  },
  {
    id: "156",
    resourceCode: "WST",
    resourceId: "882",
    resourceName: "Samoan tala",
  },
  {
    id: "157",
    resourceCode: "XAF",
    resourceId: "950",
    resourceName: "CFA franc BEAC",
  },
  {
    id: "158",
    resourceCode: "XCD",
    resourceId: "951",
    resourceName: "East Caribbean dollar",
  },
  {
    id: "159",
    resourceCode: "XDR",
    resourceId: "960",
    resourceName: "Special drawing rights",
  },
  {
    id: "160",
    resourceCode: "XOF",
    resourceId: "952",
    resourceName: "CFA franc BCEAO",
  },
  {
    id: "161",
    resourceCode: "XPF",
    resourceId: "953",
    resourceName: "CFP franc",
  },
  {
    id: "162",
    resourceCode: "XSU",
    resourceId: "994",
    resourceName: "SUCRE",
  },
  {
    id: "163",
    resourceCode: "XUA",
    resourceId: "965",
    resourceName: "ADB Unit of Account",
  },
  {
    id: "164",
    resourceCode: "YER",
    resourceId: "886",
    resourceName: "Yemeni rial",
  },
  {
    id: "165",
    resourceCode: "ZAR",
    resourceId: "710",
    resourceName: "South African rand",
  },
  {
    id: "166",
    resourceCode: "ZMW",
    resourceId: "967",
    resourceName: "Zambian kwacha",
  },
  {
    id: "167",
    resourceCode: "ZWL",
    resourceId: "932",
    resourceName: "Zimbabwean dollar",
  },
];
